import { useState, useEffect } from 'react';

export function useDeviceSize() {
  const [size, setSize] = useState({ width: 400, height: 500 });

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setSize({ width, height });
    };

    checkDevice(); // Set initially
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return size;
}
